<template>
  <div>
    <hide-at :breakpoints="{small: 767, medium: 768, large: 10024}" breakpoint="mediumAndAbove">
        <div>
            <b-nav id="mobileNavBarReport" class="mobile-sub-nav fixed-top scrollable">
                <div>
                    <b-link href="#" @click="mostraTutti" :class="{current: this.devicesType == '' || this.devicesType == null || this.devicesType == 'tutti'}">{{$t("navbar_dispositivi.all")}}</b-link>
                    <b-link href="#" @click="mostraBomIlluminazione" :class="{current: this.devicesType == 'illuminazione'}">{{$t("navbar_dispositivi.lighting")}}</b-link>
                    <b-link href="#" @click="mostraBomEmergenza" :class="{current: this.devicesType == 'emergenza'}">{{$t("navbar_dispositivi.emergency")}}</b-link>
                    <b-link href="#" @click="mostraBomSensori" :class="{current: this.devicesType == 'sensori'}">{{$t("navbar_dispositivi.sensor")}}</b-link>
                </div>
            </b-nav>
        </div>
    </hide-at>
    <show-at :breakpoints="{small: 767, medium: 768, large: 10024}" breakpoint="mediumAndAbove">
      <nav class="pl-4 pt-1 fixed-top navbar-illum">
        <b-button
        :pressed="btn_state_all"
        class="typo-label"
        variant="link"
        @click="mostraTutti">
          {{$t("navbar_dispositivi.all")}}
        </b-button>
        <b-button
        :pressed="btn_state_lighting"
        class="typo-label"
        variant="link"
        @click="mostraBomIlluminazione">
          {{$t("navbar_dispositivi.lighting")}}
        </b-button>
        <b-button
          :pressed="btn_state_emergency"
          class="typo-label"
          variant="link"
          @click="mostraBomEmergenza">
            {{$t("navbar_dispositivi.emergency")}}
        </b-button>
        <b-button
          :pressed="btn_state_sensor"
          class="typo-label"
          variant="link"
          @click="mostraBomSensori">
            {{$t("navbar_dispositivi.sensor")}}
        </b-button>       
      </nav>
    </show-at>
  </div>
  
</template>

<script>
import {showAt, hideAt} from 'vue-breakpoints';
import { mapState } from 'vuex';

export default {
  name: "NavBarBom",
  components: {
    showAt,hideAt
  },

  data() {
    return {
      devicesType: ''
    };
  },
  //mounted viene richiamato solo la prima volta che viene caricato NavBarBom
  mounted() {
    // console.log("navbar report mounted, route = ", this.$router.currentRoute);
    let routeDevType = this.$router.currentRoute.params.devicesType;
    // console.log("devicesTypes=" + this.devicesType+", routeDevType:"+routeDevType)
    if (this.devicesType != routeDevType) {
        this.devicesType = routeDevType;
    }
    //this.mostraTutti();
  },
  computed: {
    ...mapState(["loading"]),

    btn_state_all() {
      return this.devicesType === 'tutti' || this.devicesType === null || this.devicesTypes === '';
    },
    btn_state_emergency() {
      return this.devicesType === 'emergenza';
    },
    btn_state_lighting() {
      return this.devicesType === 'illuminazione';
    },
    btn_state_sensor() {
      return this.devicesType === 'sensori';
    }
  },
  watch: {
    '$route'() {
        // TODO: react to navigation event.
        // params contains the current route parameters
        console.log("route changed 2!",this.$route.params);
        this.devicesType = this.$route.params["devicesType"];
        this.$forceUpdate();
    },
    
    loading (value) {
      if (value === false) {
        this.mostraTutti();
      }
    },
  },
  methods: {
    mostraTutti() {
      console.log("mostraTutti: ", this.devicesType);
      if (this.devicesType != '' || this.devicesType != null || this.devicesType != 'tutti') {
        this.$router.push({
          name: "BomImpianto",
          params: { plantId: this.$store.state.currentPlant.id, devicesType: 'tutti' }
        });
      }
    },
    mostraBomEmergenza() {
      console.log("mostraBomEmergenza: ", this.devicesType);
      if (this.deviceType != 'emergenza') {
        this.$router.push({
          name: "BomImpianto",
          params: { plantId: this.$store.state.currentPlant.id, devicesType: 'emergenza' }
        });
      }
    },
    mostraBomIlluminazione() {
      console.log("mostraBomIlluminazione: ", this.devicesType);
      if (this.deviceType != 'illuminazione') {
        this.$router.push({
          name: "BomImpianto",
          params: { plantId: this.$store.state.currentPlant.id, devicesType: 'illuminazione' }
        });
      }
    },
    mostraBomSensori() {
      console.log("mostarBomSensori: ", this.devicesType);
      if (this.deviceType != 'sensori') {
        this.$router.push({
          name: "BomImpianto",
          params: { plantId: this.$store.state.currentPlant.id, devicesType: 'sensori' }
        });
      }
    }
  }
};
</script>
